import React from "react";
import { Link } from "react-router-dom";
function WhyChooseUs() {
  return (
    <div>
      <section className="why-choose-us-wrapper">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-4 justify-content-center">
            <div className="col-12 col-lg-6">
              <div className="section-heading text-center">
                <div className="sub-title justify-content-center text-white">
                  <img src="assets/img/core-img/hammer.png" alt="" />
                  WHY CHOOSE US
                </div>
                <h2 className="mb-0 text-white">
                  Our skills are why clients choose us.
                </h2>
              </div>
            </div>
          </div>

          <div className="divider-sm"></div>

          <div className="row">
            <div className="col-12">
              <div
                className="video-section style-two"
                style={{ backgroundImage: "url(assets/img/bg-img/69.jpg)" }}
              >
                <div className="popup-video mt-5">
                  <div
                    className="video-btn wow fadeInUp"
                    data-wow-duration="1000ms"
                    data-wow-delay="1000ms"
                    data-video="https://youtu.be/4GUFkrHvZdE"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_1_434)">
                        <path
                          d="M5.10545 0.529181C2.94172 -0.711968 1.1875 0.304796 1.1875 2.79837V21.1999C1.1875 23.6959 2.94172 24.7114 5.10545 23.4714L21.1893 14.2474C23.3538 13.0059 23.3538 10.9943 21.1893 9.753L5.10545 0.529181Z"
                          fill="#0E0E0E"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1_434">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span className="video-sonar"></span>
                  </div>
                </div>
                {/* Video Text */}
                <div className="video-text">WATCH VIDEO</div>
              </div>
            </div>
          </div>

          <div className="divider"></div>

          <div className="row g-5">
            <div className="col-12 col-lg-6">
              <div className="section-heading">
                <h2 className="mb-4 text-white">25K+</h2>
                <div className="sub-title2 text-white">
                  Justice served with integrity
                </div>
                <p className="text-white mb-0">
                  Although we are located in Brooklyn, our maritime lawyers are
                  proud to help the injured throughout the nation, including
                  workers who were working in foreign waters at the time of the
                  incident go up against the largest offshore companies and win.
                </p>
                <Link to="/casestudydetails" className="btn btn-primary mt-5">
                  <span>
                    Browse More <i className="ti ti-arrow-up-right"></i>
                  </span>
                  <span>
                    Browse More <i className="ti ti-arrow-up-right"></i>
                  </span>
                </Link>
              </div>
            </div>

            <div className="col-12 col-lg-6">
              {/* Progress Bar */}
              <div className="progress-container progress2 mb-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="progress-label lh-1">Business Growth</div>
                  <div className="progress-percentage counter lh-1">80%</div>
                </div>
                <div className="progress-bar">
                  <div className="progress-fill" data-percentage="80"></div>
                </div>
              </div>

              {/* Progress Bar */}
              <div className="progress-container progress2 mb-4">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="progress-label lh-1">Market Analysis</div>
                  <div className="progress-percentage counter lh-1">90%</div>
                </div>
                <div className="progress-bar">
                  <div className="progress-fill" data-percentage="90"></div>
                </div>
              </div>

              {/* Progress Bar */}
              <div className="progress-container progress2">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="progress-label lh-1">Market Analysis</div>
                  <div className="progress-percentage counter lh-1">100%</div>
                </div>
                <div className="progress-bar">
                  <div className="progress-fill" data-percentage="100"></div>
                </div>
              </div>

              <p className="mb-0 text-white mt-5">
                Although we are located in Brooklyn, our maritime lawyers proud
                to help the injured throughout the nation, including workers who
                were working in foreign waters at the time of the incident go up
                against the largest offshore companies and win.
              </p>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  );
}

export default WhyChooseUs;
